/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Card from 'saur_ui_library/src/Molecules/Card/Card';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import { createGlobalStyle } from 'styled-components';
import AutocompleteComponent from '../components/common/component/AutocompleteComponent';
import ChartLineComponent from '../components/common/component/ChartLineComponent';
import { VictoryTheme } from 'victory';
import {
  defineTresholds,
  defineVerticalLines,
  prepareDataForGraphics,
  prepareDatesPoints,
} from '../utils/helpers/view/pluieDetailHelper';
import ChartBoxPlotComponent from '../components/common/component/ChartBoxPlotComponent';
import ExtentIcon from '../assets/Graph/extentView.svg';
import {
  getDataQuantity,
  getDataVolume,
  getPeriodicities,
  getPluivoEvents,
  rainEventsSortedByDate,
  renderTable,
} from '../utils/helpers/module/PluieDetailHelper';
import { loaderForGraphics, renderSwitchButtons } from '../utils/helpers/view/detailsHelper';
import { TabProps } from '../utils/Interface';
import { loaderDataComponent } from '../utils/helper';
import Loader from '../components/common/Loader';

const PluieDetail = (props: any) => {
  // variables
  const [mainInstallCode] = useState<string>(props.row.Code || '');
  // view
  const [displayTableView, setDisplayTableView] = useState<string>('flex');
  // dropdownlist
  const [monthOptions, setMonthOptions] = useState<any[] | null>([]);
  const [monthSelected, setMonthSelected] = useState<any>(null);
  const [selectedMonthOption, setSelectedMonthOption] = useState<any>(null);
  // table
  const [dataTable, setDataTable] = useState<any[] | null>([]);
  const [periodicitySelected, setPeriodicitySelected] = useState<any>(null);
  // detail
  const [quantityRain, setQuantityRain] = useState<object[] | null>(null);
  const [quantityRainDates, setQuantityRainDates] = useState<object[] | null>(null);
  const [cumulativeRain, setCumulativeRain] = useState<object[] | null>(null);
  const [cumulativeRainDates, setCumulativeRainDates] = useState<object[] | null>(null);
  const [cumulativeRainTreshold, setCumulativeRainTreshold] = useState<object[] | null>(null);
  const [verticalLines, setVerticalLines] = useState<any[] | null>(null);
  const [quantityVol, setQuantityVol] = useState<object[] | null>(null);
  const [quantityVolDates, setQuantityVolDates] = useState<object[] | null>(null);
  const [cumulativeVol, setCumulativeVol] = useState<object[] | null>(null);
  const [cumulativeVolDates, setCumulativeVolDates] = useState<object[] | null>(null);
  // compare
  const [rainAndVolumeStats] = useState<object[]>([
    { x: 1, y: 2 },
    { x: 2, y: 3 },
    { x: 3, y: 5 },
    { x: 4, y: 4 },
    { x: 5, y: 6 },
  ]);
  const [rainStatsPlot] = useState<object[]>([{ x: 1, y: [1, 2, 3, 5] }]);
  const [loadingTable, setLoadingTable] = useState<boolean>(false);
  const [loadingPeriodicities, setLoadingPeriodicities] = useState<boolean>(true);
  const [errorPeriodicities, setErrorPeriodicities] = useState<boolean>(false);

  // Gestion des onglets avec un seul state
  const [tabsStates, setTabsStates] = useState<TabProps[]>([
    { id: 0, label: 'Détails', active: true },
    // { id: 1, label: 'Comparaison', active: false },
  ]);

  // provide and format data for rain graphics
  const updateRainGraphics = (pDataRain: any) => {
    let cRain: any[] = [];
    let qRain: any[] = [];

    if (pDataRain) {
      cRain = prepareDataForGraphics(pDataRain.cumulativeCurveNumbersDatas);
      qRain = prepareDataForGraphics(pDataRain.curveNumbersDatas);
    }

    setCumulativeRain(cRain);
    setCumulativeRainDates(
      prepareDatesPoints(pDataRain.cumulativeCurveNumbersDatas)
    );
    setQuantityRain(qRain);
    setQuantityRainDates(prepareDatesPoints(pDataRain.curveNumbersDatas));
    const tresholds = defineTresholds(cRain);
    setCumulativeRainTreshold(tresholds);
    setVerticalLines(defineVerticalLines(cRain, tresholds));
  };

  // provide and format data for volume graphics
  const updateVolumeGraphics = (pDataVolume: any) => {
    let cumulativeVol: any[] = [];
    let quantityVol: any[] = [];
    if (pDataVolume) {
      cumulativeVol = prepareDataForGraphics(
        pDataVolume.cumulativeDumpedVolumesDatas
      );
      quantityVol = prepareDataForGraphics(pDataVolume.dumpedVolumesDatas);
    }
    setCumulativeVol(cumulativeVol);
    setCumulativeVolDates(
      prepareDatesPoints(pDataVolume.cumulativeDumpedVolumesDatas)
    );
    setQuantityVol(quantityVol);
    setQuantityVolDates(prepareDatesPoints(pDataVolume.dumpedVolumesDatas));
  };

  // styles for blocks right and left
  const blocksStyles = {
    maxWidth: 'max-content',
    display: displayTableView,
    alignItems: 'center',
    width: '55%',
    overflow: 'auto',
    minWidth: '40%',
    height: '75vh',
  };

  const graphicBlocksStyles = {
    padding: '10px',
    width: '50%',
  };

  const chartStyles = {
    parent: {
      border: '1px solid #CCE8F6',
      borderRadius: '5px',
    },
  };

  // component did mount
  useEffect(() => {
    getPeriodicities(mainInstallCode).then((dropdonwlist) => {
      setLoadingPeriodicities(false);
      if(dropdonwlist.length > 0){
        const newList = dropdonwlist.map((date: any) => {
          const month = new Date(date.year, date.monthId-1).toLocaleString(
            'fr-FR',
            {
              month: 'long'
            }
          );
          return {
            year: date.year,
            monthId: date.monthId,
            name:
              month.charAt(0).toUpperCase() + month.slice(1) + ' ' + date.year,
          };
        });
        setMonthOptions(newList);
        setMonthSelected({ year: newList[0].year, month: newList[0].monthId });
        setSelectedMonthOption(newList[0]);
        handlerDropdownlistPeriodicities(newList[0]); // get data for the first month
      }
    }).catch(() => {
      setLoadingPeriodicities(false);
      setErrorPeriodicities(true);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // handler of dropdownlist
  const handlerDropdownlistPeriodicities = (pOption: any) => {
    setLoadingTable(true);
    resizeGraphicsView('none');
    setMonthSelected({ year: pOption.year, month: pOption.monthId });
    getPluivoEvents(pOption, mainInstallCode).then(async (d) => {
      setDataTable(rainEventsSortedByDate(d));
      setLoadingTable(false);
    }).catch(() => {
      setLoadingTable(false);
    });
  };

  // handler of radio buttons in table
  const handlerOnChangeMonthSelection = (pOption: any) => {
    resetStates();
    setSelectedMonthOption(pOption);
    if (pOption !== null) {
      handlerDropdownlistPeriodicities(pOption);
    } else {
      setMonthSelected(null);
      setPeriodicitySelected(null);
    }
  };

  const resetStates = () => {
    setQuantityVol(null);
    setQuantityVolDates(null);
    setQuantityRain(null);
    setQuantityRainDates(null);
    setCumulativeVol(null);
    setCumulativeVolDates(null);
    setCumulativeRainDates(null);
    setCumulativeRain(null);
    setVerticalLines(null);
    setCumulativeRainTreshold(null);
    setDataTable(null);
  };

  const resizeGraphicsView = (pValue: string) => {
    let newValue = 'flex';
    if (pValue !== 'none') {
      newValue = 'none';
    }
    setDisplayTableView(newValue);
  };

  const getQuantity = async (row: any) => {
    const quantity = await getDataQuantity(row);
    updateRainGraphics(quantity);
  };
  
  const getVolume = async (row: any) => {
    const volume = await getDataVolume(row);
    updateVolumeGraphics(volume);
  };

  const onChangeRadio = (event: any, row: any) => {
    setPeriodicitySelected(row);
    getQuantity(row);
    getVolume(row);

    // for multiple selections
    // const newDataTable = updateEventsTable(e, dataTable, row);
    // setDataTable(newDataTable);
  };

  return (
    <>
      <Styles />
      {/* Header */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingTop: '10px',
        }}
      >
        {/* Title : name of installation */}
        <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
          <Word value={props.row.Description} variant='h5'></Word>
        </div>
        {/* Switch buttons */}
        <div style={{ display: 'flex', width: '60%', justifyContent: 'left' }}>
          {renderSwitchButtons(tabsStates, setTabsStates)}
        </div>
      </div>
      <Loader IsVisible={loadingPeriodicities} />
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        {/* Dropdownlist */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {errorPeriodicities && (
            <span style={{ color: 'red', marginBottom: '4px', fontSize: '0.85rem' }}>
              Erreur lors du chargement des données
            </span>
          )}
          <div style={{ display: 'inline-flex' }}>
          <Container
            style={{ minWidth: '261px', maxHeight: '55px', width: '15%' }}
          >
            <Word value={'Mois :'} textStyle='normalBold' variant='span' />
              {monthOptions !== null && monthOptions.length > 0 && <AutocompleteComponent
                id={'pluie-month-selection'}
                Listoption={monthOptions}
                onChangeValue={(event, option) => {
                  handlerOnChangeMonthSelection(option);
                }}
                defaultValue={selectedMonthOption}
              />}
          </Container>
          {loaderDataComponent(loadingTable, `width: 28px;
            height: 28px;
            margin-top: 3vh;
            margin-left: 2vh;
            border: 5px solid #FFF;
            border-bottom-color: #243977;
            border-radius: 50%;
            display: inline-block;
            box-sizing: border-box;
            animation: rotation 1s linear infinite;`)}
          </div>
        </div>
        {(dataTable !== null && dataTable.length !== 0) && (
          <button
            onClick={() => {
              resizeGraphicsView(displayTableView);
            }}
          >
            <img
              src={ExtentIcon}
              title='Agrandir/Réduire les graphiques'
              alt='extentGraphics'
            ></img>
          </button>
        )}
      </div>
      <br />
      {/* Blocks */}
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        {/* left block */}
        <Container style={blocksStyles}>
          <div style={{ minWidth: '95%' }}>
            <Card automatedTestId='pluie-events-table'>
              {renderTable(
                dataTable !== null ? dataTable : [],
                onChangeRadio
              )}
            </Card>
          </div>
        </Container>
        {/* Right block */}
        <Container
          style={{
            overflow: 'auto',
            minWidth: '60%',
            maxHeight: '800px',
            position: 'relative',
            left: displayTableView === 'none' ? '20vw' : '0',
          }}
        >
          {/* Detailed view */}
          {tabsStates[0].active === true && (
            <div style={{ minWidth: '95%', display: 'grid', textAlign: 'center' }}>
              <div
                style={{
                  display: 'inline-flex',
                }}
              >
                <div style={graphicBlocksStyles}>
                  <Card className='cardSize'>
                    {monthSelected !== null && quantityRain !== null && 
                      <ChartLineComponent
                        data={{ line: quantityRain, point: quantityRain }}
                        dataDates={quantityRainDates !== null ? quantityRainDates : []}
                        chartStyles={chartStyles}
                        mainTitleParams={{
                          title: 'INTENSITE DE LA PLUIE',
                          x: 150,
                          y: 15,
                        }}
                        secondTitleParams={{
                          title: "PENDANT L'EVENEMENT PLUVIEUX",
                          x: 129,
                          y: 30,
                        }}
                        yLabel='Pluie en mm'
                        idChart={1}
                      />}
                    {monthSelected !== null && periodicitySelected !== null && quantityRain === null && loaderForGraphics(
                      '100%',
                      '38vh',
                      'loaderRainEventsGraphics')}
                    {(monthSelected === null || periodicitySelected === null) && <span>{"Sélectionnez un événement !"}</span>}
                  </Card>
                </div>
                <div style={graphicBlocksStyles}>
                  <Card className='cardSize'>
                    {monthSelected !== null && quantityVol !== null && <ChartLineComponent
                      chartStyles={chartStyles}
                      data={{ line: quantityVol, point: quantityVol }}
                      dataDates={quantityVolDates !== null ? quantityVolDates : []}
                      mainTitleParams={{
                        title: 'VOLUMES DEVERSES',
                        x: 150,
                        y: 15,
                      }}
                      secondTitleParams={{
                        title: "PENDANT L'EVENEMENT PLUVIEUX",
                        x: 129,
                        y: 30,
                      }}
                      yLabel='Volumes en m³/h'
                      idChart={2}
                    />}
                    {monthSelected !== null && periodicitySelected !== null && quantityVol === null && loaderForGraphics(
                      '100%',
                      '38vh',
                      'loaderRainEventsGraphics')}
                    {(monthSelected === null || periodicitySelected === null) && <span>{"Sélectionnez un événement !"}</span>}
                  </Card>
                </div>
              </div>
              <div
                style={{
                  display: 'inline-flex',
                }}
              >
                <div style={graphicBlocksStyles}>
                  <Card className='cardSize'>
                  {monthSelected !== null && cumulativeRain !== null && <ChartLineComponent
                      data={{ line: cumulativeRain, point: cumulativeRain }}
                      dataDates={cumulativeRainDates !== null ? cumulativeRainDates : []}
                      chartStyles={chartStyles}
                      mainTitleParams={{
                        title: 'CUMUL DE PLUIE',
                        x: 150,
                        y: 15,
                      }}
                      secondTitleParams={{
                        title: "PENDANT L'EVENEMENT PLUVIEUX",
                        x: 129,
                        y: 30,
                      }}
                      yLabel='Pluie en mm'
                      verticalLine={
                        (verticalLines !== null && verticalLines.length !== 0) ? verticalLines : []
                      }
                      stresHold={cumulativeRainTreshold !== null ? cumulativeRainTreshold : []}
                      idChart={3}
                    />}
                    {monthSelected !== null && periodicitySelected !== null && cumulativeRain === null && loaderForGraphics(
                      '100%',
                      '38vh',
                      'loaderRainEventsGraphics')}
                    {(monthSelected === null || periodicitySelected === null) && <span>{"Sélectionnez un événement !"}</span>}
                  </Card>
                </div>
                <div style={graphicBlocksStyles}>
                  <Card className='cardSize'>
                    {monthSelected !== null && cumulativeVol !== null && <ChartLineComponent
                      chartStyles={chartStyles}
                      data={{ line: cumulativeVol, point: cumulativeVol }}
                      dataDates={cumulativeVolDates !== null ? cumulativeVolDates : []}
                      mainTitleParams={{
                        title: 'VOLUMES DEVERSES CUMULES',
                        x: 150,
                        y: 15,
                      }}
                      secondTitleParams={{
                        title: "PENDANT L'EVENEMENT PLUVIEUX",
                        x: 129,
                        y: 30,
                      }}
                      yLabel='Volumes en m³'
                      idChart={4}
                    />}
                    {monthSelected !== null && periodicitySelected !== null && cumulativeVol === null && loaderForGraphics(
                      '100%',
                      '38vh',
                      'loaderRainEventsGraphics')}
                    {(monthSelected === null || periodicitySelected === null) && <span>{"Sélectionnez un événement !"}</span>}
                  </Card>
                </div>
              </div>
            </div>
          )}
          {/* Compare view */}
          {tabsStates.length > 1 && tabsStates[1]?.active === true && (
            <>
              <div
                style={{
                  display: 'flex',
                  maxHeight: 'max-content',
                  marginBottom: '5px',
                }}
              >
                <Card>
                  <ChartLineComponent
                    data={{ line: rainAndVolumeStats }}
                    chartTheme={VictoryTheme.material}
                    chartStyles={chartStyles}
                    chartResolution={{
                      width: 500,
                      height: 320,
                    }}
                    mainTitleParams={{
                      title: 'RELATION PLUIE - VOLUME DEVERSE',
                      x: 150,
                      y: 15,
                    }}
                    yLabel='Volume déversé par événements pluvieux (m³)'
                    xLabel="Lame d'eau de pluie (m³)"
                    idChart={5}
                  />
                </Card>
              </div>
              <div style={{ display: 'flex', maxHeight: 'max-content' }}>
                <Card>
                  <ChartBoxPlotComponent
                    mainTitle='SEUIL DE PLUIE DONNANT LIEUX A UN DEVERSEMENT'
                    data={rainStatsPlot}
                  />
                </Card>
              </div>
            </>
          )}
        </Container>
      </div>
    </>
  );
};

export const Styles = createGlobalStyle`

.sds-reset-style{
  .loaderRainEventsGraphics {
    width: 48px;
    height: 48px;
    border: 5px solid #FFF;
    border-bottom-color: #243977;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
  }
  .cardSize {
    height: 38vh;
    justify-content: center;
  }
  .sds-container.generalContainer{
    flex-direction:row;
    }
  .global-pr-container{
    .global-pr-content{
      margin-left: 50px;
    }
    margin-left: auto;
    margin-right: auto;
    height:30vh;
    flex-direction:row;
  .pompe-info{
    flex-direction: row;
    margin-bottom: 10px;
    .warning{
      flex-direction: row; 
    }
    #warning-text{
      margin-left:5px;
      color:#FE3123
    }
    .warning-logo{
      margin-left:20px;
    }
    #pompe-derniere-remontee{
     margin-left: 16px;
     margin-right: 5px;
    }
    #pompe-q{
     margin-right: 5px;
    }
  }
  .sds-container.sds-m-card.global-data-pr-container{
    overflow: unset;
    width: 90vw;
    }

  #global-data-pr-container{
    padding: 0 2vw;
    width: 90vw;
    }

 #pompe1,#pompe2,#pompe3,#pompe4{
   margin-bottom: 2vw;
   margin-top: 2vw
    }
 #global-pr-name{
   margin-bottom: 2vw;
   margin-top: 1vw;
    }
  .text-right{
   align-self: flex-end;
   text-decoration: underline;
   margin-left: 75px;
   /* height: 100%; */
   height: 2.5em; /* hauteur du parent */
    }
  }
  .pluvio-text-right{
   align-self: flex-end;
   margin-bottom: 50px;
   flex-direction: row;   
   margin-right: 10px;

  }
  .global-data-header{
    flex-direction: row;
    /* width: fit-content; */
    height: 53px;
    width: 100%;
  }
  #pluvio-switch{
      margin-right: 15px;
      vertical-align: middle;
    }
}

`;
export default PluieDetail;
